import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import AOS from "aos";
import "aos/dist/aos.css";
import "@fontsource/ubuntu/300.css";
import "@fontsource/ubuntu/400.css";
import "@fontsource/ubuntu/500.css";
import "@fontsource/ubuntu/700.css";
import "@fontsource/inter/400.css";

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

AOS.init();

// JavaScript
$(document).ready( function () {
  //scroll top
  // $('.back-to-top').click(function(event){
  //   $("html,body").animate({scrollTop: 0}, 1000);
  // });

  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  // 子選單
  $('.menu-link').click(function(e) {
      $(this).parent().toggleClass('active').siblings().removeClass('active');
  });
  $('.menu-dropdown-toggle').on('click', function() {
    $(this).parent().toggleClass('active').siblings().removeClass('active');
  });

  // 首頁輪播
  if ( $('#indexBanner').length != 0 ) {
    var indexBanner = new Swiper('#indexBanner', {
      effect: 'fade',
      autoplay: {
        delay: 5000,
      },
      loop: true,
      speed: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });
  }

  // 彙總頁分類Tabs
  if ( $('#pageCateSwiper').length != 0 ) {
    var swiper = new Swiper("#pageCateSwiper", {
      slidesPerView: "auto",
      spaceBetween: 0,
      freeMode: true,
      watchOverflow: true,
      navigation: {
        nextEl: ".page-cate-group .swiper-button-next",
        prevEl: ".page-cate-group .swiper-button-prev",
      },
    });

    // 分類Tabs-水平置中
    if ( $('.js-page-cate-group-center').length != 0 ) {
      let totalWidth = 0;
      function setSwiperCenter() {
        totalWidth = 0;
        $('#pageCateSwiper .swiper-slide').each(function (index) {
          totalWidth += $(this).width();
          return totalWidth;
        });
        if ( $('#pageCateSwiper').width() > totalWidth ) {
          $('#pageCateSwiper .swiper-wrapper').css('justify-content', 'center');
        } else {
          $('#pageCateSwiper .swiper-wrapper').css('justify-content', 'flex-start');
        }
      }
      setSwiperCenter();
      let pageCateResizeTimer; // resize計時器
      $(window).on('resize', function() {
        clearTimeout(pageCateResizeTimer);
        pageCateResizeTimer = setTimeout(function () {
          setSwiperCenter();
        }, 300);
      });
    }
  }

  // 產品component頁 - 子分類錨點
  let $productsSubCateAnchors = $('.products-sub-cate-anchor');
  if ( $productsSubCateAnchors.length != 0 ) {
    let navHeight = $('#header').innerHeight();
    $productsSubCateAnchors.on('click', function() {
      var target = $(this.hash);
      $('html, body').animate({
        scrollTop: target.offset().top - navHeight - 30
      }, 1000);
      return false;
    });
  }

  // 產品system頁 - sku卡片輪播
  if ( $('#productsSystemSKUSwiper').length != 0 ) {
    var productsSystemSKUSwiper = new Swiper("#productsSystemSKUSwiper", {
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        1280: { // >= 1280px 時
          slidesPerView: 3,
          spaceBetween: 24,
        },
        800: { // >= 800px 時
          slidesPerView: 2,
          spaceBetween: 12,
        },
        0: { // >= 0px 時
          slidesPerView: 1,
          spaceBetween: 12,
        }
      },
    });
  }

  // 產品system-產品內容頁 - 產品輪播
  if ( $('#productSlider').length != 0 ) {
    // 產品縮圖輪播
    var productThumbsSlider = new Swiper("#productThumbsSlider", {
      loop: true,
      observer: true, 
      observeParents: true,
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      on: {
        init: function () {
          if (this.slides.length <= 1) {
            $(this.el).addClass('is-single');
          }
        },
      },
    });
    // 產品大圖輪播
    var productSlider = new Swiper("#productSlider", {
      loop: true,
      observer: true, 
      observeParents: true,
      navigation: {
        nextEl: '.product-slider-wrap .swiper-button-next',
        prevEl: '.product-slider-wrap .swiper-button-prev',
      },
      thumbs: {
        swiper: productThumbsSlider,
      },
    });
  }

  // 產品收合區塊 - 產品System頁-SKU列表 (全部收合)
  let $accordionAllWraps = $('.js-accordion-all-wrap');
  if ( $accordionAllWraps.length != 0 ) {
    $accordionAllWraps.each(function(index, element) {
      let $accordionWrap = $(this);
      let $accordionToggle = $(this).find('.accordion-toggle');
      let $accordionContent = $(this).find('.accordion-content');
      let accordionContentHeight = $accordionContent.outerHeight();

      // 綁定收合功能
      $accordionToggle.on('click', function() {
        // 想關閉
        if ( $accordionWrap.hasClass('active') ) {
          setAccordionContentHeight('hide');
          $accordionWrap.removeClass('active');
        // 想開啟
        } else {
          setAccordionContentHeight('open');
          $accordionWrap.addClass('active');
        }
      });

      // init: 預設隱藏第一個以外的區塊
      $accordionContent.css('height', `${accordionContentHeight}px`);  // 全部展開的高度
      if ( index != 0 ) {
        $accordionToggle.click();
      }

      // 取得區塊高度
      function updateHeight() {
        accordionContentHeight = $accordionContent.outerHeight();
      }

      // 設定 content 區塊高度
      function setAccordionContentHeight(type) {
        switch (type) {
          case 'open':
            $accordionContent.css('height', `${accordionContentHeight}px`);  // 全部展開的高度
            break;
          case 'hide':
            $accordionContent.css('height', `${0}px`);  // 全部收合
            break;
        }
      }

      // resize event
      let accordionResizeTimer; // resize計時器
      $(window).on('resize', function() {
        clearTimeout(accordionResizeTimer);
        accordionResizeTimer = setTimeout(function () {
          $accordionContent.css('height', 'auto');
          updateHeight();
          let type = $accordionWrap.hasClass('active') ? 'open' : 'hide';
          setAccordionContentHeight(type);
        }, 300);
      });
    });
  }

  // 產品收合區塊 - 產品component頁-產品列表 (產品項目 > 5 時才收合)
  let $accordionLimitWraps = $('.js-accordion-limit-wrap');
  if ( $accordionLimitWraps.length != 0 ) {
    $accordionLimitWraps.each(function(index, element) {
      let $accordionWrap = $(this);
      let $accordionToggle = $(this).find('.accordion-toggle');
      let $accordionContent = $(this).find('.accordion-content');
      let accordionContentHeight = $accordionContent.outerHeight();
      
      let $productItems = $(this).find('.products-item');
      let productItemsLimit = 5;
      let productItemsLimitHeight = 0;

      // 取得元素高度
      function updateHeight() {
        accordionContentHeight = $accordionContent.outerHeight();
        productItemsLimitHeight = 0;
        $productItems.each(function(index, element) {
          if ( index < productItemsLimit ) {
            productItemsLimitHeight+=$(this).outerHeight();
          }
        });
      }

      // 設定 content 區塊高度
      function setAccordionContentHeight(type) {
        switch (type) {
          case 'open':
            $accordionContent.css('height', `${accordionContentHeight}px`);  // 全部展開的高度
            break;
          case 'hide':  // 僅保留五個項目的高度
            $accordionContent.css('height', `${productItemsLimitHeight + 40}px`); // 加上gap
            break;
        }
      }

      // init: 當產品項目 > 5 時, 將 > 5 的項目收合, 未大於 5 則不顯示收合按鈕
      if ( $productItems.length > productItemsLimit ) {
        updateHeight();
        setAccordionContentHeight('hide');
      } else {
        $accordionToggle.hide();
      }

      // toggle event
      $accordionToggle.on('click', function() {
        let type = $accordionWrap.hasClass('active') ? 'hide' : 'open';
        setAccordionContentHeight(type);
        $accordionWrap.toggleClass('active');
      });

      // resize event
      let accordionResizeTimer; // resize計時器
      $(window).on('resize', function() {
        clearTimeout(accordionResizeTimer);
        accordionResizeTimer = setTimeout(function () {
          if ( $productItems.length <= productItemsLimit ) return; 
          $accordionContent.css('height', 'auto');
          updateHeight();
          let type = $accordionWrap.hasClass('active') ? 'open' : 'hide';
          setAccordionContentHeight(type);
        }, 300);
      });
    });
  }

  // 聯絡我們頁-上傳檔案區塊
  if ( $('.file-wrap').length != 0 ) {
    const $fileInput = $('#file-input');
    const $fileName = $('.file-name');
    const $uploadBtn = $('#js-file-upload')
    const $deleteBtn = $('#js-file-delete');
    $deleteBtn.hide();

    // 清空
    function clearFileInput() {
      $fileInput.val('');
      $fileName.text('');
      $deleteBtn.hide();
    }

    $uploadBtn.on('click', function() {
      $fileInput.click();
    });

    $deleteBtn.on('click', function() {
      clearFileInput();
    });

    $fileInput.on('change', function() {
      const files = this.files;
      if ( files && files.length > 0 ) {
        const name = files[0].name;
        $fileName.text(name);
        $deleteBtn.show();
      } else {
        clearFileInput();
      }
    });
  }

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });
});

